import type { ChangeEvent } from 'react';
import { Inline } from '@etg/wings';
import { Checkbox } from '@eti/form';
import { useProperty, useSnowplowTracking, useTranslation } from '@eti/providers';
import { DangerousHtmlContent } from '@eti/components';
import { persistInputData } from '@eti/utils';
import { TRAVELER_DETAILS } from '../../../../constants/formNamesConstants';
import { contactFields } from '../../constants/formFields';

const Newsletter = () => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Traveler Details',
        action: 'Select',
        label: 'Newsletter opt out',
        property: checked,
      });
    }
    if (p('IbeClient.TravelerDetails.PersistFormData.Enabled')) {
      persistInputData(TRAVELER_DETAILS, contactFields.NEWSLETTER)(checked);
    }
  };

  return (
    <Inline alignY="top" noWrap spacing={8}>
      <Checkbox
        id="newsletter-input"
        name={contactFields.NEWSLETTER}
        onChange={(event) => handleOnChange(event)}
      />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor="newsletter-input">
        <DangerousHtmlContent content={t('ContactForm.Newsletter.Text')} />
      </label>
    </Inline>
  );
};

export default Newsletter;
